package com.eladfinish.bible.contest.screens.names.utils

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.screens.names.data.Gender
import com.eladfinish.bible.contest.screens.names.data.InternalNameLink
import com.eladfinish.bible.contest.screens.names.data.LinkInfo

expect class LinkInfoProvider() {

    fun getLinkInfos(
        text: String,
    ): List<LinkInfo>

}

fun getInternalLinkInfo(
    letter: Char,
    name: String,
    text: String,
): List<InternalNameLink> {
    val internalNameLinkList = mutableListOf<InternalNameLink>()
    findInternalTableLink(text)?.let {
        val genderAlias = it.groupValues[1]
        internalNameLinkList +=
            InternalNameLink(
                gender = genderOfTableAlias(genderAlias) ?: run {
                    AppCrashlytics.logException(IllegalArgumentException("Unknown gender alias: $genderAlias"))
                    Gender.MALE
                },
                letter = letter,
                name = name,
                start = it.start,
                end = it.end,
            )
    }
    return internalNameLinkList
}

// Kept free of AppCrashlytics so commonTest can exercise it: reaching Crashlytics from the iOS
// test binary pulls in FIRCrashlytics, which that binary doesn't link.
// (?!WORD_CHAR) rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR)
internal fun findInternalTableLink(text: String): MatchResult? =
    "ראו בטבלת ה".plus("(.*?)(?!$WORD_CHAR)").toRegex().find(text)

internal fun genderOfTableAlias(alias: String): Gender? =
    when (alias) {
        "נשים" -> Gender.FEMALE

        "גברים",
        "אנשים",
            -> Gender.MALE

        else -> null
    }

private val WEB_URL = """https?://\S+""".toRegex()

// The platform-independent stand-in for Android's Linkify.WEB_URLS: every http(s) address in the
// text, without the punctuation of the sentence around it. A closing parenthesis stays when the
// address opened it (Wikipedia titles such as "..._(name)").
internal fun findWebUrlLinks(text: String): List<LinkInfo> =
    WEB_URL.findAll(text).mapNotNull { match ->
        var url = match.value
        while (url.isNotEmpty()) {
            val last = url.last()
            val isTrailingPunctuation = last in ".,;:!?\"'" ||
                (last == ')' && url.count { it == ')' } > url.count { it == '(' })
            if (!isTrailingPunctuation) break
            url = url.dropLast(1)
        }
        if (url.substringAfter("://").isEmpty()) return@mapNotNull null
        LinkInfo(url = url, start = match.start, end = match.start + url.length)
    }.toList()
